import { createSelector, type Selector } from 'reselect';
import { get } from 'lodash';
import type { AppState } from 'src/reducers';
import { getDataFromCache } from 'src/services/pivotServiceCache';
import type { TreePivot } from 'src/worker/pivotWorker.types';
import { filterData } from 'src/utils/Pivot/Filter';
import type { AssortmentPublishViewDefns } from './AssortmentPublish.types';
import { externalGridSearchFields } from 'src/utils/Domain/Constants';

const getData: Selector<AppState, TreePivot> = (state) => {
  return getDataFromCache(state.pages.assortmentBuild.assortmentPublish)?.tree || [];
};

const getViewDefns: Selector<AppState, AssortmentPublishViewDefns> = (state) => {
  return state.pages.assortmentBuild.assortmentPublish.viewDefns;
};

const getFlowStatus: Selector<AppState, number[]> = (state) => {
  return state.subheader.flowStatus;
};

const getSearch: Selector<AppState, string> = (state) => {
  return state.subheader.search;
};

export const processAssortmentPublishData = createSelector(
  getData,
  getViewDefns,
  getSearch,
  getFlowStatus,
  (data, viewDefns, search, flowStatus) => {
    const configSearchOrDefafult: readonly string[] = get(viewDefns, 'grid.searchIndexes', externalGridSearchFields);
    const filteredData = filterData(data, search, configSearchOrDefafult, flowStatus);
    return filteredData;
  },
);
